import React from 'react'
import Page from 'routes/SearchGCSE'

const Home = () => <Page />

export default Home
